import { TError, TState } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../members/axios';

export const getStateByIdQueryKey = (id: number | undefined) => ['geography', 'states', id] as const;

export const useGetStateByIdQuery = (id: number | undefined) =>
  useQuery<TState, TError>({
    queryKey: getStateByIdQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<TState>(`geography/states/${id}`);
      return data;
    },
    enabled: !!id,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
